<script>
import groupBy from 'lodash/groupBy'
import includes from 'lodash/includes'
import mapValues from 'lodash/mapValues'
import orderBy from 'lodash/orderBy'

import { mapGetters } from 'vuex'

export default {

  computed: {

    ...mapGetters([
      'collectedItems'
    ]),

    collectedItemsByType () {
      return mapValues(groupBy(this.collectedItems, 'type'), (items) => {
        return orderBy(items, ({ id }) => {
          return this.itemIsUsed(id)
        })
      })
    }

  },

  methods: {

    itemIsUsed (itemId) {
      return includes(this.$store.getters.usedItemIds, itemId)
    },

    useItem (itemId) {
      this.$store.dispatch('useItem', itemId)
    }

  }

}
</script>

<template>
  <div class="c-inventory">
    <div class="c-inventory-items">

      <template
        v-for="items in collectedItemsByType"
      >

        <button
          v-for="{ id, type } in items"
          :key="id"
          :class="{
            'c-inventory-item-used': itemIsUsed(id),
            'c-inventory-item-usable': !itemIsUsed(id)
          }"
          class="c-inventory-item"
          @click="useItem(id)"
        >
          {{ type }}
        </button>

      </template>

    </div>
  </div>
</template>

<style lang="scss">

.c-inventory {
  @include small-font;
}

.c-inventory-items {
  @include flex;
  @include flex-center;
}

.c-inventory-item {
  @include flex;
  @include flex-center;
  @include pad-tight;
  @include radius;
  background-color: translucent($black, 0.8);

  &:not(:last-child) {
    margin-right: $pad-tight-horizontal;
  }

}

.c-inventory-item-used {
  opacity: 0.4;
}

</style>
